import { PublicEnvironment } from '~/lib/utils';

export function PublicEnvironmentProvider(props?: PublicEnvironment | null) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `window.ENV = ${JSON.stringify(props)}`,
      }}
    />
  );
}

export const getPublicEnvironment = (): PublicEnvironment | null =>
  typeof window !== 'undefined' ? window.ENV : null;
